import React from 'react';
import styled from 'styled-components';

// Moved the styles into here as they're now scoped to this page,
// They were affecting the global h1, p styled previously.
const Container = styled.div`
  text-align: center;
  margin-top: 40px;
  display: block;
`;

class NotFound extends React.Component {
  render() {
    return (
      <Container>
        <h1>Not Found</h1>
        <p>We're sorry, the content you are looking for could not be found.</p>
      </Container>
    );
  }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound/index.jsx